import React from "react";
import cs from "classnames";
import { Modal, ModalBody } from "reactstrap";

import insightsIcon from "../../../assets/images/insights.svg";
import { Button } from "../Button/Button";

import "./InsightsLoaderModal.scss";

interface InsightsLoaderModalProps {
  isOpen: boolean;
  insightsType: "rooms" | "desks";
  roomsCount?: number;
  desksCount?: number;
  className?: string;
  onCancel?: () => void;
}

export const InsightsLoaderModal = ({
  isOpen,
  insightsType,
  roomsCount,
  desksCount,
  className,
  onCancel,
}: InsightsLoaderModalProps) => {
  const description =
    insightsType === "rooms"
      ? `Gathering data across ${roomsCount ?? 0} rooms`
      : `Gathering data across ${desksCount ?? 0} desks`;

  return (
    <Modal
      isOpen={isOpen}
      centered
      backdrop="static"
      keyboard={false}
      className={cs("InsightsLoaderModal", className)}
    >
      <ModalBody className="InsightsLoaderModal__body">
        <div
          className="InsightsLoaderModal__spinner"
          role="status"
          aria-label="Still preparing your insights report..."
        />
        <h3>Still preparing your insights report...</h3>
        <p className="InsightsLoaderModal__description">{description}</p>
        <img
          className="InsightsLoaderModal__icon"
          src={insightsIcon}
          alt=""
          aria-hidden="true"
        />
        <p className="InsightsLoaderModal__helper">
          <span>We should be done soon.</span>
          <strong>Thanks for your patience.</strong>
        </p>
        <Button
          className="InsightsLoaderModal__cancel"
          title="Cancel"
          color="simple"
          size="small"
          onClick={onCancel}
        />
      </ModalBody>
    </Modal>
  );
};
